<div id="wrapper">
    <app-loading-screen [status]=false></app-loading-screen>
    <div>
        <app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
    </div>
    <div>
        <app-tab-nav [visible]="false" (updatePostpaid)="this.postpago=$event" (updatePrepaid)="this.prepago=$event" (updateFixed)="this.telefoniaFijo=$event" (updateTotalAccountList)="this.totalAccountList=$event" (updateCurrentList)="this.currentList=$event"
            (updateSelectBan)="this.selectBan=$event" (updateInitializeData)="this.initializeData()"></app-tab-nav>
    </div>
    <app-add-product *ngIf="this.totalAccountList==0"></app-add-product>
    <div class="basicrow">
        <div class="basicrow">
            <div class="container">
                <div class="fulltitle m-top-i f-btitle logo">
                    <span><img class="cclub-icon" src="../assets/images/icon_claro club_3-01.png" style="width: 58px;height: 37px;"></span> Términos y Condiciones Claro Club
                </div>
            </div>
        </div>
        <div class="basicrow roboto-r f-reg f-black m-top m-bott aux">
            <div class="container">
                <app-collapse [(content)]="this.content"></app-collapse>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>